<template>
  <section class="ratio ratio-16x9">
    <iframe :src="video" title="YouTube video" allowfullscreen>
    </iframe>
  </section>
</template>
<script setup>
import { defineProps } from 'vue';
  defineProps({
    video: {
      type: String,
      required: true,
    }
  });
</script>